import React, { useRef, useState } from "react";
import bannerImage from "../../../../Images/theme-41-banner.png";
// import topright from "../../../../Images/theme18-top-right.png";
// import logoImage from "../../../../Images/Saloonlogo1.jpg";
// import testimonialImage from "../../../../Images/avatar.png";
// import FacebookIcon from "../../../../Images/theme18-social1.png";
// import InstagramIcon from "../../../../Images/theme-18-social2.png";
// import TweeterIcon from "../../../../Images/theme-18-social3.png";
// import LinedinIcon from "../../../../Images/theme18-social4.png";
// import WhatsappIcon from "../../../../Images/theme-18-social5.png";
import CalanderIconn from "../../../../Images/theme18-calendarIcondays.png";

import "./Theme41.css";
import TestimonialWrapper from "../../../Components/Testimonials/TestimonialWrapper";
import PortfolioWrapper from "../../../Components/Portfolios/PortfolioWrapper";
const Theme41Template = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const calendarInputRef = useRef(null);
  const testimonialArray = [
    {
      name: "Rachel McDermott",
      description:
        "I have been under their care for several years now to every appointment.",
      formCount: "0",
      image: "null",
    },
    {
      name: "Ernest Reinger",
      description:
        "I have been under their care for several years now to every appointment.",
      formCount: "1",
      image: "null",
    },
    {
      name: " Reinger",
      description:
        "I have been under their care for several years now to every appointment.",
      formCount: "2",
      image: "null",
    },
  ];
  const galleryArray = [
    {
      id: 46,
      business_id: 10,
      image: "chef1.png",
      created_by: 72,
      created_at: "2023-11-30T06:52:18.000Z",
      updated_at: "2023-11-30T06:52:18.000Z",
    },
    {
      id: 47,
      business_id: 10,
      image: "chef2.png",
      created_by: 72,
      created_at: "2023-11-30T06:52:22.000Z",
      updated_at: "2023-11-30T06:52:22.000Z",
    },
    {
      id: 48,
      business_id: 10,
      image: "chef3.png",
      created_by: 72,
      created_at: "2023-11-30T06:52:26.000Z",
      updated_at: "2023-11-30T06:52:26.000Z",
    },
    {
      id: 49,
      business_id: 10,
      image: "chef4.png",
      created_by: 72,
      created_at: "2023-11-30T06:52:31.000Z",
      updated_at: "2023-11-30T06:52:31.000Z",
    },
  ];

  const openCalendar = () => {

    if (calendarInputRef.current) {
      calendarInputRef.current.showPicker();

    }
  };
  return (
    <div>
      <div class="main-temaplt" id="temp41">
        <div className="container">
          <div className="row justify-content-center">
            <div style={{ width: "420px" }} className="col-12 wtemplate">

              <article className="imgsechere sec">
                {/* <div className="imgsechere-top">
                  <div className="imgsechere-top-left">  9:41  </div>
                  <div className="imgsechere-top-right"> <img loading="lazy" src={topright} alt="top right" />  </div>
                </div> */}
                <div className="imgsechere-main-banner">
                <img
                  src={bannerImage}
                  className="mx-auto d-block img-fluid coverimghere "
                  style={{ width: "100%" }}
                />
                </div>                
              </article>


              {/* <div>
                  <img
                    src={logoImage}
                    className="mx-auto d-block img-fluid logo-profile"
                  />
                </div> */}
              <article className="personalinfo">
                <h3 className="username">John Doe</h3>
                <p className="titleuser"> French Chef </p>
              </article>

              <article className="abouttemplate sec">
                <h3 class="sectitle">About us</h3>
                <p className="para">
                  {`Passion for food has driven me to every nook and corner of the world. From becoming the youngest executive chef at a five star hotel, to hosting my own cooking shows, it is my love for cooking that has got this far. Through this website, I intend to take you on a culinary journey, exploring new places, cultures and flavours. Let’s engage, exchange and evolve our skills and taste buds.`}
                </p>
              </article>
              <article class="contact sec">
                <h3 class="sectitle">Contact Info</h3>
                <ul class="conlink">
                  <li>
                    <a href="">
                      <i class="fa-solid fa-phone"></i>
                      <span>{`987654321`}</span>
                    </a>
                  </li>

                  <li>
                    <a href="">
                      <i class="fa-solid fa-envelope"></i>
                      <span>{`John@Doe.com`}</span>
                    </a>
                  </li>

                  <li>
                    <a href="">
                      <i class="fa-solid  fa-location-dot"></i>
                      <span>{`No 17A / 22, Ajmal Khan Road,`}</span>
                    </a>
                  </li>
                </ul>
              </article>

              <article className="social-links-sec sec">
                <h3 class="sectitle">Social Media</h3>
                <ul class="socil-link socil-link-inner">
                  <li>
                    <a>
                      <i class={`fa-brands fa-facebook`}></i>
                      {/* <img loading="lazy" src={FacebookIcon} /> */}
                    </a>
                  </li>
                  <li>
                    <a>
                      <i class={`fa-brands fa-google`}></i>
                      {/* <img loading="lazy" src={InstagramIcon} /> */}
                    </a>
                  </li>

                  <li>
                    <a>
                      <i class={`fa-brands fa-twitter`}></i>
                      {/* <img loading="lazy" src={TweeterIcon} /> */}
                    </a>
                  </li>
                  <li>
                    <a>
                    <i class="fa-brands fa-whatsapp"></i>
                      {/* <img loading="lazy" src={WhatsappIcon} /> */}
                    </a>
                  </li>
                  <li>
                    <a>
                    <i class="fa-brands fa-linkedin-in"></i>
                      {/* <img loading="lazy" src={LinedinIcon} /> */}
                    </a>
                  </li>
                </ul>
              </article>

              <article className="servicesName sec">
                <h3 class="sectitle">Services </h3>
                <div className="mainservicebox">
                  <ul className="servesbox">
                    <li>Food preparation </li>
                    <li>Menu planning </li>
                    <li>Kitchen management </li>
                    <li> Event catering</li>
                    {/* <li>Pediatric </li>
                    <li> Orthopedics</li> */}
                  </ul>
                </div>
              </article>

              <PortfolioWrapper portfolioData={galleryArray} theme="temp41" />

              {/* <article className="businessHours sec">
                <h3 class="sectitle">Working Hours</h3>

                <ul class="timelist">
                  <li>
                    <div className="day">Monday :</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                  <li>
                    <div className="day">Tuesday :</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                  <li>
                    <div className="day">Wednesday :</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                  <li>
                    <div className="day">Thursday :</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                  <li>
                    <div className="day">Friday :</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                  <li>
                    <div className="day">Saturday :</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                </ul>
              </article> */}



              <article className="makeappitmneets sec">
                {/* <h3 class="sectitle">Make Appointment</h3> */}
                <div className="contact-form">
                  <div class="col-12 mb-3" style={{ position: "relative" }}>
                    <input
                      ref={calendarInputRef}
                      type="date"
                      class="form-control clear_string"
                      placeholder="Date"
                      name="currentDate"
                    // value={selectedDate}
                    // onChange={(e) => setSelectedDate(e.target.value)}
                    />
                    <div className="calanderIcon" onClick={openCalendar}><img loading="lazy" src={CalanderIconn} alt="Calendar Icon" /></div>
                  </div>
                  <div class="col-12 mb-3">
                    <select
                      class="form-select"
                      aria-label="Default select example"
                    // onChange={(e) => setSelectedTime(e.target.value)}
                    >
                      <option value="Select time">Select time</option>
                      <option>{`2:00 PM to 5:00 PM`}</option>
                    </select>
                  </div>
                  <div class="col-12 mb-3">
                    <button
                      className="btn btnmakeappitmnets"
                      data-bs-toggle="modal"
                      data-bs-target="#appotimnets"
                    >
                      Make An Appointment
                    </button>
                  </div>
                </div>
              </article>


           
          
          
            
              {/* <article className="makeappitmneets sec">
                <h3 class="sectitle">Make Appointment</h3>
                <div className="contact-form">
                  <div class="col-12 mb-3">
                    <input
                      type="date"
                      class="form-control clear_string"
                      placeholder="Date"
                      name="currentDate"
                      // value={selectedDate}
                      // onChange={(e) => setSelectedDate(e.target.value)}
                    />
                  </div>
                  <div class="col-12 mb-3">
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      // onChange={(e) => setSelectedTime(e.target.value)}
                    >
                      <option value="Select time">Select time</option>
                      <option>{`2:00 PM - 5:00 PM`}</option>
                    </select>
                  </div>
                  <div class="col-12 mb-3">
                    <button
                      className="btn btnmakeappitmnets"
                      data-bs-toggle="modal"
                      data-bs-target="#appotimnets"
                    >
                      Make An Appointment
                    </button>
                  </div>
                </div>
              </article> */}

              <article className="conatctform sec">
                <h3 class="sectitle">Contact Form</h3>
                <div class="contact-form">
                  <form>
                    <div class="col-12 mb-3">
                      <input
                        type="text"
                        class="form-control clear_string"
                        placeholder="Full Name"
                        name="last_name"
                        value=""
                        required=""
                      />
                    </div>
                    <div class="col-12 mb-3">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="abc@gmail.com"
                        name="email"
                        value=""
                        required=""
                      />
                    </div>
                    <div class="col-12 mb-3">
                      <input
                        type="text"
                        class="form-control clear_string"
                        maxlength="10"
                        minlength="10"
                        placeholder="Mobile Number"
                        name="mobile_number"
                        value=""
                        required=""
                      />
                    </div>
                    <div class="col-12 mb-3">
                      <textarea
                        class="form-control clear_string"
                        rows="3"
                        placeholder="Your message goes here..."
                        required=""
                        name="message"
                      ></textarea>
                    </div>

                    <div class="col-12 mb-3">
                      <button type="submit" class="btn btn-submitform">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </article>
           
              <TestimonialWrapper theme="temp41" />
        
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Theme41Template;